import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {
  ToastPlugin, ModalPlugin, BootstrapVue, IconsPlugin,
} from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import Toast, { POSITION } from 'vue-toastification'
import { extend } from 'vee-validate'
import {
  required, email, min, regex,
} from 'vee-validate/dist/rules'
import router from './router'
import store from './store'
import App from './App.vue'
import axios from './services/http.interceptor'
import 'vue-toastification/dist/index.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// นำเข้าไฟล์ข้อความแปลภาษา
import th from './i18n/th'
import en from './i18n/en'
import jp from './i18n/่jp'

extend('required', required)
extend('email', email)
extend('min', min)
extend('regex', regex)

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'th',
  messages: {
    th,
    en,
    jp,
  },
})

// bootstrap
Vue.use(BootstrapVue)
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(IconsPlugin)
// Composition API
Vue.use(VueCompositionAPI)

// use toasted
Vue.use(Toast, {
  position: POSITION.TOP_CENTER,
  timeout: 5000,
})

Vue.prototype.$toast = Vue.prototype.$toast || null

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  beforeCreate() {
    Vue.prototype.$http = axios
  },
  created() {
    this.$store.dispatch('initializeStore')
  },
  render: h => h(App),
}).$mount('#app')
